import request from '@/utils/request3'
import store from '@/store'
const serviceName = store.state.serviceName.managementService


//增加用户明细
export function postUserInsert(data) {
    return request({
        url: serviceName + `/user/add`,
        method: 'post',
        data: data
    })
}
//删除用户数据
export function postUserDelete(data) {
    return request({
        url: serviceName + `/user/delete`,
        method: 'post',
        data: data
    })
}
//修改密码
export function restPassword(data) {
    return request({
        url: serviceName + `/user/recover-pwd?id=` + data,
        method: 'get',
    })
}
//分页查询用户明细
export function getUserList(data) {
    return request({
        url: serviceName + `/user/list`,
        method: 'post',
        data: data
    })
}
//分页查询用户明细
export function getUserSelectByPage(data) {
    return request({
        url: serviceName + `/work-order/pageUser`,
        method: 'post',
        data: data
    })
}
//修改项用户明细
export function postUserUpdate(data) {
    return request({
        url: serviceName + `/user/update`,
        method: 'post',
        data: data
    })
}
//id查询用户
export function getIDUser(data) {
    return request({
        url: serviceName + `/user/${data}`,
        method: 'get',
    })
}
//id查询用户
export function getRoleList(data) {
    return request({
        url: serviceName + `/role/list2`,
        method: 'get',
    })
}
//修改用户状态
export function postUserStatus(data) {
    return request({
        url: serviceName + `/user/isValid`,
        method: 'post',
        data: data
    })
}